import { DataSource } from 'common/enum/data-source'

type DataSourceItem = {
  source?: DataSource | string
  is_selected?: boolean
}

export type DataSourceGroups<T> = {
  template: T[]
  doctor: T[]
  hasVisible: boolean
}

export const filterByDataSource = <T extends DataSourceItem>(
  items: T[]
): DataSourceGroups<T> => {
  const template = items.filter(
    (item) => item.source === DataSource.TEMPLATE && item.is_selected
  )
  const doctor = items.filter((item) => item.source === DataSource.DOCTOR)

  return {
    template,
    doctor,
    hasVisible: template.length > 0 || doctor.length > 0
  }
}
